import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "department", "contractType", "search"]
  static values = {
    url: String
  }

  connect() {
    this.debouncedSubmit = this.debounce(this.submit.bind(this), 300)
  }

  filter() {
    this.debouncedSubmit()
  }

  submit() {
    (document.querySelector("#employee_profile_search")).requestSubmit()
  }

  reset() {
    this.departmentTarget.value = ""
    this.contractTypeTarget.value = ""
    this.searchTarget.value = ""
    this.submit()
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
} 